import { render, staticRenderFns } from "./BIMainView.vue?vue&type=template&id=2a13e981"
import script from "./BIMainView.vue?vue&type=script&lang=js"
export * from "./BIMainView.vue?vue&type=script&lang=js"
import style0 from "./BIMainView.vue?vue&type=style&index=0&id=2a13e981&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports